import * as _ from "lodash";
import { React } from "react";
import moment from "moment";
import Cookies from "js-cookie";
import Lottie from "lottie-react";
import Swal from "sweetalert2";
import shoppingAnimation from "../image/shopping.json";
import {
  ACCESS_TOKEN,
  S3_URL,
  SHOP_DATA,
  SHOW_NOTICE_EXPIRED,
  USER_KEY,
  USER_KEY2,
  WEB_LANDING_PAGE_URL,
} from "../constants";
import BasicModal from "../components/BasicModal";
import { laoToThaiconsonants } from "../constants/laoToThaiconsonants";
export const orderStatus = (status) => {
  switch (status) {
    case "WAITING":
      return "ອໍເດີ້ເຂົ້າ";
      break;
    case "DOING":
      return "ກໍາລັງຄົວ";
      break;
    case "SERVED":
      return `ເສີບແລ້ວ`;
      break;
    default:
      return "ຍົກເລີກແລ້ວ";
      break;
  }
};

export const moneyCurrency = (value) => {
  if (value) {
    let currencys = new Intl.NumberFormat("en-CA").format(value);
    return currencys;
  } else {
    return 0;
  }
};
export const getUserDataFromLCStorage = () => {
  const user = JSON.parse(localStorage.getItem(USER_KEY2));
  return user;
};

export const useAuth = () => {
  const userData = localStorage.getItem(USER_KEY2);
  // const isAuthenticated = !_.isEmpty(userData)
  return userData ? true : false;
};
export const convertCurrentDate = (data) => {
  const _timeZone = moment(data).format("DD/MM/YYYY");
  return _timeZone;
};

export const _statusCheckBill = (item) => {
  if (item === "CALLTOCHECKOUT") {
    return "ຕ້ອງການຈ່າຍເງີນ";
  } else if (item === "ACTIVE") {
    return "ມີອໍເດີ້";
  } else if (item === "CHECKOUT") {
    return "ຊຳລະເງີນສຳເລັດ";
  } else if (item === "CART") {
    return "ກຳລັງສັ່ງອາຫານ";
  }
};
export const STATUS_USERS = (item) => {
  if (item === "ADMIN") {
    return "ຜູ້ໃຫ້ບໍລິຫານ";
  } else if (item === "USER") {
    return "ພະນັກງານ";
  } else if (item === "STORE") {
    return "ຜູ້ບໍລິຫານ";
  }
};
export const STATUS_MENU = (item) => {
  if (item === "HAS") {
    return "ເປີດ";
  } else if (item === "DONOT") {
    return "ປິດ";
  }
};

export const imageRender = (filename) => {
  if (!filename || typeof filename !== "string") return "/images/noPhoto.png";
  const value = filename.trim();
  if (!value) return "/images/noPhoto.png";
  if (/^(https?:)?\/\//i.test(value) || /^data:/i.test(value) || /^blob:/i.test(value)) return value;
  return S3_URL + value;
};

export const thousandSeperate = (num) =>
  num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";

export const convertTimeYYYYMMDDhhmm = (timeStamp) => {
  // return filename ? "https://lailaocf73052-staging.s3-ap-southeast-1.amazonaws.com/public/" + filename :"/images/noPhoto.png"
};

export const numberFormat = (_number) => {
  return new Intl.NumberFormat("en-US").format(_number);
};

export const formatPrice = (value) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0, // Adjust as needed
    maximumFractionDigits: 2 // Adjust as needed
  }).format(value);
};


// convert price
export const calculateRoundedValue = (price) => {
  // console.log("calculateRoundedValue------->", price)
  let integerPart = Math.floor(price);
  let decimalPart = price - integerPart;

  if (decimalPart < 0.5 && decimalPart != 0) {
    return integerPart + 0.5;
  } else if (decimalPart === 0.5 || decimalPart == 0) {
    return price;
  } else {
    return integerPart + 1;
  }
};

export const convertCurrency = (currency) => {
  switch (currency) {
    case "ກີບ":
    case "LAK":
      return "₭";
    case "ບາດ":
    case "BAHT":
      return "฿";
    case "ໂດລາ":
    case "USD":
      return `$`;
    default:
      return "₭";
  }
};

export const mapCurrency = (currency) => {
  switch (currency) {
    case "ກີບ":
    case "LAK":
      return "LAK";
    case "ບາດ":
    case "BAHT":
      return "BAHT";
    case "ໂດລາ":
    case "USD":
      return "USD";
    default:
      return "LAK";
  }
};

export const checkExpiredShop = (shop) => {
  if (_.isEmpty(shop)) return;
  localStorage.setItem(SHOP_DATA, JSON.stringify(shop));
  const showNoticExpired = Cookies.get(SHOW_NOTICE_EXPIRED);
  if (showNoticExpired) return;

  //Check if shop is blocked
  // console.log({ shop })
  if (shop.isBlocked) {
    Swal.fire({
      icon: "error",
      title: "ບັນຊີຮ້ານຄ້າຂອງທ່ານບໍ່ສາມາດໃຊ້ງານໄດ້!",
      html:
        `<div className="text-left">` +
        "ຕິດຕໍ່ຫາທີມງານດູແລລະບົບເພື່ອເຂົ້າໃຊ້ງານລະບົບ<br/>" +
        "</div>",
      showConfirmButton: false,
      timer: 20000,
    });
    localStorage.clear();
    Cookies.remove(ACCESS_TOKEN);
    Cookies.remove(SHOW_NOTICE_EXPIRED);
    return;
  }

  if (shop?.paymentType === "POINT") {
    if (shop?.point < 0) {
      // console.log('shop?.point: ', shop?.point)
      Swal.fire({
        icon: "error",
        title: "ບັນຊີຮ້ານຄ້າຂອງທ່ານຫມົດເວລາການໃຊ້ງານແລ້ວ!",
        html:
          `<div className="text-left">` +
          "ກະລຸນາຕິດຕໍ່ຫາທີມງານດູແລລະບົບເພື່ອຕໍ່່ອາຍຸການໃຊ້ງານລະບົບ<br/>" +
          "</div>",
        showConfirmButton: false,
        timer: 20000,
      });
      localStorage.clear();
      Cookies.remove(ACCESS_TOKEN);
      Cookies.remove(SHOW_NOTICE_EXPIRED);
      return;
    }
    if (shop?.point <= 1000) {
      Swal.fire({
        icon: "warnin",
        title: "ບັນຊີຮ້ານຄ້າຂອງທ່ານພ້ອຍຈະຫມົດແລ້ວ!",
        html:
          `<div className="text-left">` +
          `ຈໍານວນປ້ອຍຂອງທ່ານຍັງເຫລືອ: <h4>${shop?.point}</h4><br/>` +
          `ກະລຸນາຕິດຕໍ່ກັບທີມງານ 4B ເພື່ອເຕີມພ້ອຍ` +
          "</div>",
        showConfirmButton: false,
        timer: 20000,
      });
    }
  } else {
    var toDate = moment().format("YYYY-MM-DD");
    var endDate = moment(shop?.endDate, "YYYY-MM-DD");
    var caculateDays = endDate.diff(toDate, "days");
 

    if (caculateDays < 0) { 

      Swal.fire({
        title: "ບັນຊີຮ້ານຄ້າຂອງທ່ານຫມົດເວລາການໃຊ້ງານແລ້ວ",
        text: "ກະລຸນາຕິດຕໍ່ຫາທີມງານດູແລລະບົບ ຫຼື ຄຣິກເຂົ້າ ເຕີມແພັກເກັດ ເພື່ອຕໍ່່ອາຍຸການໃຊ້ງານລະບົບ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ເຕີມແພັກເກັດ",
        cancelButtonText: "ຍົກເລີກ",
      }).then((result) => {
        if (result.isConfirmed) {
          window.open(WEB_LANDING_PAGE_URL + "/#pricing");
        }
      });

      localStorage.clear();
      Cookies.remove(ACCESS_TOKEN);
      Cookies.remove(SHOW_NOTICE_EXPIRED);
      return;
    }
    if (caculateDays < 3) { 

      Swal.fire({
        title: "ບັນຊີຮ້ານຄ້າຂອງທ່ານຈະຫມົດເວລາການໃຊ້ງານແລ້ວ",
        html:
          `<div>ເວລາທີ່ສາມາດນໍາໃຊ້ລະບົບໄດ້ຍັງເຫລືອ: <h4>${caculateDays} ມື້</h4> <br/>` +
          `ກະລຸນາຕິດຕໍ່ກັບທີມງານ 4B ຕໍ່ເວລາການນໍາໃຊ້ຂອງທ່ານ ຫຼື ສາມາດເຕີມແພັກເກັດ ເອງໄດ້ເລີຍ</div>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ເຕີມແພັກເກັດ",
        cancelButtonText: "ຍົກເລີກ",
      }).then((result) => {
        if (result.isConfirmed) {
          window.open(WEB_LANDING_PAGE_URL + "/#pricing");
        }
      });
    }
  } 
  Cookies.set(SHOW_NOTICE_EXPIRED, true, { expires: 1 / 2 });
};


export const speakInThai = (text) => {
  const speech = new SpeechSynthesisUtterance();
  speech.text = text;
  speech.lang = "th-TH"; // Set the language to Thai
  // speech.volume = 1;
  // speech.rate = 1;
  // speech.pitch = 1;

  window.speechSynthesis.speak(speech);
};

export function convertThaiToLao(thaiText) {
  let laoText = '';
  for (let char of thaiText) {
    laoText += laoToThaiconsonants[char] || (['a', 'A'].includes(char) ? (char + '. ') : char); // Fallback to the original character if no mapping exists
  }
  return laoText;
}

export function convertNumberToWords(numString) {
  const numToWord = {
    '0': 'ศูนย์', '1': 'หนึ่ง', '2': 'สอง', '3': 'สาม', '4': 'สี่',
    '5': 'ห้า', '6': 'หก', '7': 'เจ็ด', '8': 'แปด', '9': 'เก้า',
  };

  return numString.split('').map(char => numToWord[char] || char).join('');
};

export const getStartDate = (filter) => {
  switch (filter) {
    case "today":
      return moment().startOf("day").toISOString();
    case "yesterday":
      return moment().subtract(1, "day").startOf("day").toISOString();
    case "thisWeek":
      return moment().startOf("week").toISOString();
    case "lastWeek":
      return moment().subtract(1, "week").startOf("week").toISOString();
    case "thisMonth":
      return moment().startOf("month").toISOString();
    case "lastMonth":
      return moment().subtract(1, "month").startOf("month").toISOString();
    case "thisYear":
      return moment().startOf("year").toISOString();
    case "lastYear":
      return moment().subtract(1, "year").startOf("year").toISOString();
    default:
      return null;
  }
};

export const getEndDate = (filter) => {
  switch (filter) {
    case "today":
      return moment().endOf("day").toISOString();
    case "yesterday":
      return moment().subtract(1, "day").endOf("day").toISOString();
    case "thisWeek":
      return moment().endOf("week").toISOString();
    case "lastWeek":
      return moment().subtract(1, "week").endOf("week").toISOString();
    case "thisMonth":
      return moment().endOf("month").toISOString();
    case "lastMonth":
      return moment().subtract(1, "month").endOf("month").toISOString();
    case "thisYear":
      return moment().endOf("year").toISOString();
    case "lastYear":
      return moment().subtract(1, "year").endOf("year").toISOString();
    default:
      return null;
  }
};

export const ConvertDay = (day) => {
  let laoday = "";
  switch (day) {
    case "today":
      return (laoday = "ມື້ນີ້");
    case "yesterday":
      return (laoday = "ມື້ວານ");
    case "thisWeek":
      return (laoday = "ທິດນີ້");
    case "lastWeek":
      return (laoday = "ທິດກອ່ນ");
    case "thisMonth":
      return (laoday = "ເດືອນນີ້");
    case "lastMonth":
      return (laoday = "ເດືອນກອ່ນ");
    case "thisYear":
      return (laoday = "ປີນີ");
    case "lastYear":
      return (laoday = "ປີກອ່ນ");
    default:
      return laoday;
  }
};

export const startDateAndEndDate = (of = "month", format = "YYYY-MM-DD") => {
  let startMonth = moment().startOf(of).format(format); //2018-04
  let endMonth = moment().endOf(of).format(format); //2018-04
  return { startMonth, endMonth };
};

export const NewCovertTimeZone = (date, format = "YYYY-MM-DD") => {
  return moment(date).tz("Asia/Bangkok").format(format);
}


export const splitDateTime = (dateString, isEndOfDay = false) => {
  if (!dateString) return null;
  let date = moment(dateString);
  if (isEndOfDay) {
    date = date.endOf("day");
  } else {
    date = date.startOf("day");
  }
  return date.toISOString();
};

export const convertStatusInvoiceClaim = (values) => {
  let status = "";
  switch (values) {
    case "REQUESTING":
      return (status = "ກຳລັງຂໍເຄມ");
    case "APPROVING":
      return (status = "ກຳລັງອະນຸມັດ");
    case "REJECTED":
      return (status = "ປະຕິເສດ");
    case "CREATED":
      return (status = "ຂໍເຄມເງິນໃໝ່");
    case "CHECKING":
      return (status = "ກຳລັງກວດສອບຄວາມຖຶກຕ້ອງ");
    case "CANCELED":
      return (status = "ຍົກເລິກແລ້ວ");
    case "FINISHED":
      return (status = "ສຳເລັດທຸລະກຳ");
    default:
      return status;
  }
}

export const convertStatusPaid = (values) => {
  let status = "";
  switch (values) {
    case "PAYMENT_COMPLETED":
      return (status = "ຊຳລະສຳເລັດ");
    case "CLOSED":
      return (status = "ຍົກເລີກການຊຳລະ");
    default:
      return status;
  }
}

export const convertPriceWithCommission = (sumPriceKip, sumPriceBaht, sumPriceUsd, _taxPrice, shopRate) => {


  let _sumBaht = 0;
  let _sumUsd = 0;
  let _sumKip = sumPriceKip || 0;

  // Convert sumPriceBaht to kip
  if (sumPriceBaht) {
    _sumBaht = sumPriceBaht * (shopRate?.baht || 0);
  }

  // Convert sumPriceUsd to kip
  if (sumPriceUsd) {
    _sumUsd = sumPriceUsd * (shopRate?.usd || 0);
  }

  // Apply commission if provided
  if (_taxPrice) {
    _sumKip += _taxPrice;
  }

  // Calculate total in kip
  const totalInKip = _sumBaht + _sumUsd + _sumKip;
  const totalResponse = calculateRoundedValue(totalInKip / 1000) * 1000;
  return totalResponse;
};

export const checkLogoLogictics = (type) => {
  let hal = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqApAoxPZ2kMZ2WyGcxY_8fR9Klsqm_hAN8Q&s";
  let mixay = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwsP1N9sEQz_EASyy90rDvyE1uUKOW6u3sUA&s";
  let anusit = "https://anousith-express.co/images/site_login_box.jpg";

  switch (type) {
    case "HAL":
      return hal;
    case "MIXAY":
      return mixay;
    case "ANUSITH":
      return anusit;
    default:
      return hal;
  }
}

export const convertLogicticsName = (name) => {
  if (!name) return "";
  
  switch (name) {
    case "HAL":
      return "ຮຸ່ງອາລຸນ";
    case "MIXAY":
      return "ມີໄຊ";
    case "ANUSITH":
      return "ອານຸສິດ";
    default:
      return name; // Return the original name if no mapping exists
  }
}

